/* Z Cell navigation. Commerce uses Shopify's normal product forms and cart route. */
(() => {
  const init = root => {
    root.querySelectorAll('[data-zc-header]').forEach(header => {
      if (header.dataset.zcReady) return;
      header.dataset.zcReady = 'true';
      const toggles = [...header.querySelectorAll('[data-zc-menu-toggle], [data-zc-search-toggle]')];
      const closePanels = except => toggles.forEach(button => {
        if (button === except) return;
        button.setAttribute('aria-expanded', 'false');
        const panel = document.getElementById(button.getAttribute('aria-controls'));
        if (panel) panel.hidden = true;
      });
      toggles.forEach(button => button.addEventListener('click', () => {
        const panel = document.getElementById(button.getAttribute('aria-controls'));
        if (!panel) return;
        const open = button.getAttribute('aria-expanded') !== 'true';
        closePanels(button);
        panel.hidden = !open;
        button.setAttribute('aria-expanded', String(open));
        if (open && button.matches('[data-zc-search-toggle]')) panel.querySelector('input[type=search]')?.focus();
      }));
      const desktopGroups = [...header.querySelectorAll('.zc-nav-group')];
      desktopGroups.forEach(group => group.addEventListener('toggle', () => {
        if (group.open) desktopGroups.forEach(other => { if (other !== group) other.open = false; });
      }));
      header.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const openToggle = toggles.find(button => button.getAttribute('aria-expanded') === 'true');
        closePanels();
        openToggle?.focus();
        desktopGroups.forEach(group => {
          if (group.open) { group.open = false; group.querySelector('summary')?.focus(); }
        });
      });
      document.addEventListener('click', event => {
        if (!header.isConnected || header.contains(event.target)) return;
        closePanels();
        desktopGroups.forEach(group => { group.open = false; });
      });
      header.querySelector('.zc-mobile-menu')?.addEventListener('click', event => {
        if (event.target.closest('a')) closePanels();
      });

      header.querySelectorAll('[data-zc-predictive-search]').forEach(form => {
        const input = form.querySelector('input[type=search]');
        const results = form.querySelector('.zc-search-predictions');
        if (!input || !results) return;
        let request;
        let timer;
        const closeResults = () => {
          results.hidden = true;
          results.innerHTML = '';
          input.setAttribute('aria-expanded', 'false');
        };
        input.addEventListener('input', () => {
          window.clearTimeout(timer);
          request?.abort();
          const term = input.value.trim();
          if (term.length < 2) {
            closeResults();
            return;
          }
          timer = window.setTimeout(async () => {
            request = new AbortController();
            const parameters = new URLSearchParams({
              q: term,
              'resources[type]': 'product,collection',
              'resources[limit]': '6',
              'resources[options][unavailable_products]': 'hide',
              'resources[options][fields]': 'title,product_type,variants.title,vendor',
              section_id: 'zcell-predictive-search'
            });
            try {
              const response = await fetch(`${window.Shopify.routes.root}search/suggest?${parameters}`, { signal: request.signal });
              if (!response.ok) throw new Error('Search request failed');
              const html = new DOMParser().parseFromString(await response.text(), 'text/html');
              const section = html.querySelector('#shopify-section-zcell-predictive-search');
              if (!section || input.value.trim() !== term) return;
              results.innerHTML = section.innerHTML;
              results.hidden = false;
              input.setAttribute('aria-expanded', 'true');
            } catch (error) {
              if (error.name !== 'AbortError') closeResults();
            }
          }, 180);
        });
        input.addEventListener('keydown', event => {
          if (event.key === 'Escape') closeResults();
          if (event.key !== 'ArrowDown' || results.hidden) return;
          event.preventDefault();
          results.querySelector('a')?.focus();
        });
        form.addEventListener('focusout', event => {
          if (!form.contains(event.relatedTarget)) window.setTimeout(closeResults, 100);
        });
      });
    });
  };
  const start = () => {
    init(document);
    if (window.jQuery) {
      window.jQuery(document.body).off('ajaxCart.afterCartLoad.zcell').on('ajaxCart.afterCartLoad.zcell', (_event, cart) => {
        if (!cart || typeof cart.item_count !== 'number') return;
        document.querySelectorAll('.zc-cart-count').forEach(counter => { counter.textContent = String(cart.item_count); });
        document.querySelectorAll('.zc-cart-link').forEach(link => { link.setAttribute('aria-label', 'Cart, ' + cart.item_count + ' items'); });
      });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
